import { render, staticRenderFns } from "./nuevoUsuario.vue?vue&type=template&id=626b35c9&scoped=true&"
import script from "./nuevoUsuario.vue?vue&type=script&lang=js&"
export * from "./nuevoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./nuevoUsuario.vue?vue&type=style&index=0&id=626b35c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b35c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VIcon,VSelect,VSwitch,VTextField})
